/**
 * PlanPath - plan_11 (Money plan). The step path from the Diary money plan:
 * round steps on a line, done ones ticked in lilac, the current one ringed.
 * `flow` draws a dashed line instead (for money moving from one place to
 * the next). Steps: { emoji, label, sub, amount, amountBg, amountInk,
 * bg, done, now, onClick, selected }.
 * plan_14: a step with onClick can be tapped; `selected` rings it darker.
 */
const PlanPath = ({ steps = [], flow = false, progress = 0 }) => {
  const n = Math.max(steps.length, 1);
  const inset = 50 / n + '%';
  const p = Math.max(0, Math.min(1, progress || 0));
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', margin: '18px 0 4px' }} data-testid="plan-path">
      {n > 1 && (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute', left: inset, right: inset, top: 21, height: 3, borderRadius: 2,
            background: flow ? 'repeating-linear-gradient(90deg, #CDBDF3 0 6px, transparent 6px 11px)' : '#ECE6FB',
          }}
        />
      )}
      {!flow && n > 1 && p > 0 && (
        <span
          aria-hidden="true"
          style={{ position: 'absolute', left: inset, top: 21, height: 3, borderRadius: 2, background: '#A58BE6', width: `calc((100% - ${100 / n}%) * ${p})` }}
        />
      )}
      {steps.map((s, i) => (
        <div
          key={i}
          role={s.onClick ? 'button' : undefined}
          tabIndex={s.onClick ? 0 : undefined}
          aria-pressed={s.onClick ? !!s.selected : undefined}
          onClick={s.onClick}
          style={{ position: 'relative', zIndex: 1, flex: 1, minWidth: 0, textAlign: 'center', cursor: s.onClick ? 'pointer' : undefined, WebkitTapHighlightColor: 'transparent' }}
        >
          <span
            style={{
              width: 44, height: 44, margin: '0 auto', borderRadius: 999, display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: s.done ? 16 : 18, border: '2px solid #FFFFFF',
              background: s.done ? '#A58BE6' : s.now ? '#FFFFFF' : (s.bg || '#F4F1FB'),
              color: s.done ? '#FFFFFF' : undefined,
              boxShadow: s.selected ? '0 0 0 3px #A58BE6' : s.now ? '0 0 0 3px #CDBDF3' : 'none',
            }}
          >
            {s.done ? '✓' : s.emoji}
          </span>
          <span style={{ display: 'block', fontSize: 11.5, fontWeight: s.now || s.selected ? 600 : 500, color: s.now || s.selected ? '#7B5FC9' : '#9A9AA2', marginTop: 6, lineHeight: 1.25, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '0 2px' }}>
            {s.label}
          </span>
          {s.sub ? (
            <span style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#55565C', marginTop: 2, whiteSpace: 'nowrap' }}>{s.sub}</span>
          ) : null}
          {s.amount ? (
            <span style={{ display: 'inline-block', marginTop: 5, fontSize: 11.5, fontWeight: 600, borderRadius: 999, padding: '3px 8px', background: s.amountBg || '#ECE6FA', color: s.amountInk || '#7B5FC9', whiteSpace: 'nowrap' }}>
              {s.amount}
            </span>
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default PlanPath;
